<div class="card border border-light-subtle p-3">
    <div
        class="d-flex align-items-center gap-1 overflow-auto rounded mb-3 mr-2 py-2 px-3 w-auto ms-3 bg-gray border-bottom">
        <button (click)="editor.chain().focus().toggleBold().run()" matTooltip="Bold"
            [disabled]="!editor.can().chain().focus().toggleBold().run()" class="editor-btn"
            [ngClass]="editor.isActive('bold') ? 'editor-btn-active' : 'editor-text-muted'">
            <lucide-icon [img]="Bold" class="editor-icon-sm"></lucide-icon>
        </button>
        <button (click)="editor.chain().focus().toggleItalic().run()" matTooltip="Italic"
            [disabled]="!editor.can().chain().focus().toggleItalic().run()" class="editor-btn"
            [ngClass]="editor.isActive('italic') ? 'editor-btn-active' : 'editor-text-muted'">
            <lucide-icon [img]="Italic" class="editor-icon-sm"></lucide-icon>
        </button>

        <button (click)="editor.chain().focus().toggleUnderline().run()" matTooltip="Underline"
            [disabled]="!editor.can().chain().focus().toggleUnderline().run()" class="editor-btn"
            [ngClass]="editor.isActive('underline') ? 'editor-btn-active' : 'editor-text-muted'">
            <lucide-icon [img]="Underline" class="editor-icon-sm"></lucide-icon>
        </button>

        <div class="h-4 w-px bg-border mx-1"></div>
        <button (click)="editor.chain().focus().toggleBulletList().run()" matTooltip="Bullet list" class="editor-btn"
            [ngClass]="editor.isActive('bulletList') ? 'editor-btn-active' : 'editor-text-muted'">
            <lucide-icon [img]="List" class="editor-icon-sm"></lucide-icon>
        </button>
        <button (click)="editor.chain().focus().toggleOrderedList().run()" matTooltip="Ordered list" class="editor-btn"
            [ngClass]="editor.isActive('orderedList') ? 'editor-btn-active' : 'editor-text-muted'">
            <lucide-icon [img]="ListOrdered" class="editor-icon-sm"></lucide-icon>
        </button>
        <div class="h-4 w-px bg-border mx-1"></div>

        <button (click)="editor.chain().focus().undo().run()" matTooltip="Undo"
            [disabled]="!editor.can().chain().focus().undo().run()"
            class="editor-btn editor-text-muted disabled:opacity-50">
            <lucide-icon [img]="Undo" class="editor-icon-sm"></lucide-icon>
        </button>
        <button (click)="editor.chain().focus().redo().run()" matTooltip="Redo"
            [disabled]="!editor.can().chain().focus().redo().run()"
            class="editor-btn editor-text-muted disabled:opacity-50">
            <lucide-icon [img]="Redo" class="editor-icon-sm"></lucide-icon>
        </button>
        <div class="h-4 w-px bg-border mx-1"></div>
        <button type="button" class="editor-btn editor-text-muted disabled:opacity-50" matTooltip="Copy"
            aria-label="Copy"
            (click)="onClipboarbCopy()">
            <lucide-icon [img]="copiedType === 'formatted' ? Check : Copy"
                class="editor-icon-sm"></lucide-icon>
        </button>
    </div>

    <!-- Editor -->
    <div class="rounded bg-white editor-container">
        <tiptap-editor [editor]="editor"></tiptap-editor>
    </div>
</div>
